
import axios from 'axios'

export const getProgramsSetup = async () => {
  const url = 'https://lk.k31.ru/api/v7/checkup/setup'
  const response = await axios.get(url)

  if (response.status !== 200) {
    throw new Error(
      response.data.message ?? 'Произошла ошибка, попробуйте позже'
    )
  }
  return response.data
}
